<template lang="pug">
Tabs.ticket-hub
    //- contains-table: a panel card is flush (body padding 0) and its content
    //- carries the spacing, the way every paginated list in the admin is built.
    el-card.contains-table(shadow="always")
        project-list(scope="cms")
</template>

<script>
import Tabs from '@/extensions/communication/views/Partials/Tabs';
import ProjectList from '@/extensions/tickets/views/Projects/ProjectList';

/**
 * The shop's own projects. `/tickets/projects` keeps the message hub's Tickets
 * tab marked, so projects need no tab and no sidebar entry of their own - and
 * the two can never fall out of sync.
 */
export default {
    name: 'CmsProjectList',
    components: {
        Tabs,
        'project-list': ProjectList,
    },
};
</script>
